// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { useSocket } from '@/context/socket-context/use-external-socket.ts';
import { FaHand } from 'react-icons/fa6';
import { useAuth } from '@/context/auth-context/use-auth.ts';
import { useGlobalSFX } from '@/context/sfx-context/use-sfx.ts';
import { useCallUIStore } from '@/stores/call-ui-store';

export const RaiseHandButton = ({ channelId, className }: { channelId: string; className?: string }) => {
  const { raisedHand, setRaisedHand } = useCallUIStore();
  const { user } = useAuth();
  const socket = useSocket();

  const sfx = useGlobalSFX();

  const toggleRaiseHand = () => {
    const next = !raisedHand;
    setRaisedHand(next);

    next ? sfx.raiseHand.play() : sfx.lowerHand.play();

    if (socket && user?.id) {
      socket.send(
        JSON.stringify({
          type: 'update-raised-hand',
          channelId: channelId,
          participantIdentity: user.name,
          raisedHand: next,
        })
      );
    }
  };
  return (
    <button
      onClick={toggleRaiseHand}
      className={`flex ${
        raisedHand
          ? 'bg-yellow-500 hover:bg-yellow-600'
          : 'bg-foreground-100 hover:bg-foreground-200'
      } items-center rounded-sm px-2 py-1 font-bold transition-colors duration-200 hover:text-white`}
    >
      <FaHand
        className={`${className} ${raisedHand ? 'animate-shake text-white' : 'text-yellow-500'}`}
      />
    </button>
  );
};
